import React from 'react';
import { Tabs, TabsProps } from 'antd';
import styled from 'styled-components';
import ThemeCheckIn from './components/ThemeCheckIn';
import MarketingWaitingCheck from './components/MarketingWaitingCheck';
import colorTheme from 'constant/colors';

const ThemeCheckInPage = () => {
  const items: TabsProps['items'] = [
    {
      key: 'theme-check-in',
      label: 'Theme Check-in',
      children: <ThemeCheckIn />,
    },
    {
      key: 'marketing-waiting-check',
      label: 'Marketing Waiting Check',
      children: <MarketingWaitingCheck />,
    },
  ];

  return (
    <Container>
      <Tabs
        defaultActiveKey='theme-check-in'
        items={items}
        className='theme-check-in-tabs'
      />
    </Container>
  );
};

export default ThemeCheckInPage;

const Container = styled.div`
  width: 100%;

  .ant-form {
    font-family: Poppins;
  }

  & .theme-check-in-tabs {
    .ant-tabs-nav {
      background: none;
      width: 100%;
      height: auto;
      min-height: 0;
    }

    .ant-tabs-tab-active {
      background: none;

      .ant-tabs-tab-btn {
        color: ${colorTheme.primary_active};
      }
    }

    .ant-tabs-ink-bar {
      background: ${colorTheme.primary_active};
    }
  }
`;
